import SubmitTicket from "../content/public/SubmitTicket";
import Header from "../components/Header";

const Home = () => {
  return (
    <>
      <Header />
      <SubmitTicket referringPage={"public"} />
    </>
  );
};

export default Home;
